var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"d-flex pa-2 flex-column align-center justify-center",style:({
    'margin-bottom': '40px',
    width: '80%',
    'min-height': '550px',
    height: 'fit-content',
  }),attrs:{"outlined":"","elevation":"2"}},[_c('div',{staticClass:"d-flex flex-column justify-center align-center",style:({
      'text-align': 'center',
      width: '70%',
      padding: '50px 0px 50px 0px',
    })},[_c('p',[_vm._v(" Terimakasih ! "),_c('br'),_vm._v(" Data Merchant telah berhasil di submit. ")]),_c('p',[_vm._v("No Pengajuan: "+_vm._s(_vm.referenceNumber))]),_c('v-row',{attrs:{"align":"center"}},[_c('v-btn',{style:({ margin: '2px' }),attrs:{"small":"","color":"warning","dark":""},on:{"click":_vm.goHome}},[_vm._v(" Home ")]),_c('v-btn',{style:({ margin: '2px' }),attrs:{"small":"","color":"primary","dark":""},on:{"click":_vm.goTracking}},[_vm._v(" tracking pengajuan ")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }